import React from 'react';
import { CustomText } from '@vfit/shared/atoms';
import { IMoreOfferSelector } from '../../moreOfferSelector.models';
import MoreOfferElement from './components/MoreOfferElement/moreOfferElement';

const MoreOfferMobile = ({ elements, title, moreOfferMobileModal }: IMoreOfferSelector) => {
  if (elements?.length === 0) return null;
  return (
    <>
      {title && (
        <CustomText text={title} size={36} lineHeight={50} sizeMobile={30} lineHeightMobile={38} />
      )}
      <MoreOfferElement
        label={moreOfferMobileModal || ''}
        arrow={'down'}
        elements={elements}
        border="border"
      />
    </>
  );
};

export default MoreOfferMobile;
